import { render, staticRenderFns } from "./SalesInvoiceForm.vue?vue&type=template&id=00b6b806"
import script from "./SalesInvoiceForm.vue?vue&type=script&lang=js"
export * from "./SalesInvoiceForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports